import i18n from './i18n'
import {getUrl} from './url'

const pageText = window?.fe?.getPageText(i18n)
/* global Vue */
const Message = Vue.prototype.$message
const Loading = Vue.prototype.$loading

const $https = (function () {
  const _Vue = window.fe.vue
  return new _Vue().$http
})()

// ajax
export default function response (
  {
    method = 'get',
    url,
    params = {},
    headerParams = {},
    option = {}
  }
) {
  return _response($https(method, url, params, headerParams, option.isLoading), option)
}

// 页面loading
function loadingFn (loadingOptions, pageText) {
  // load 默认配置
  const loadingOptionsDefault = {
    text: pageText.desperatelyLoading,
    background: 'rgba(255, 255, 255, 0.8)',
    spinner: 'el-icon-loading'
  }
  // 通过判断参数类型来区分是否合并参数 字符串：使用默认参数 对象：合并参数
  const isLoadingOptions = typeof loadingOptions === 'object'
  const loading = {
    state: !!loadingOptions,
    instance: null,
    option: isLoadingOptions ? Object.assign(loadingOptionsDefault, loadingOptions) : loadingOptionsDefault,
    hide: function () {
      if (this.state) {
        this.instance.close()
      }
    }
  }
  if (loading.state) {
    loading.instance = Loading(loading.option)
  }
  return loading
}

function _response (promise, option) {
  let optionDefault = {
    authError: true, // 权限错误
    tokeInvalidError: true, // token 无效错误
    showError: true, // 是否处理错误信息
    code: null,      // 错误code 对应提示
    loadingOptions: null // loading 配置
  }
  // 合并传入options
  option = typeof option === 'object' ? Object.assign(optionDefault, option) : optionDefault

  let {showError, code, loadingOptions, authError, tokeInvalidError} = option
  const loading = loadingFn(loadingOptions, pageText)

  return promise.then(res => {
    const data = res.data || {}
    const currentPageRequest = res._currentPageRequest
    // 如果不是同一个页面请求 不处理
    if (!currentPageRequest) {
      authError = false
      showError = false
    }

    if (data.code === 'success') {
      data.isOk = true
    } else {
      let handleAuthError = false // 是否处理过权限错误
      data.isOk = false

      // 错误code处理
      let vueInstantiation = window.vueInstantiation // vue 实例
      let isJump = vueInstantiation._route.path !== '/member/login' // 如果已经在登录页面就不需要跳转了
      const {project, loginWay} = window.fe

      if (data.code === 'NO_LOGIN') {
        if (project === 'mall' && authError) {
          if (data.loginSource === 'outer') {
            window.location.href = getUrl(`/userauth/ssoLogin/toLoginPage?clientType=${project}&backRoute=${encodeURIComponent(window.location.href)}${loginWay ? `&loginWay=${loginWay}` : ''}`)
          } else {
            if (process.env.NODE_ENV !== 'development') {
              window.location.href = getUrl(`/purchaser/${loginWay ? `?loginWay=${loginWay}` : ''}#/member/login?url=${encodeURIComponent(window.location.href)}&isMall=true`)
            } else {
              window.location.href = getUrl(`/${loginWay ? `?loginWay=${loginWay}` : ''}#/member/login?url=${encodeURIComponent(window.location.href)}&isMall=true`)
            }
          }
        } else if (project === 'supplier' && authError && isJump) {
          if (data.loginSource === 'outer') {
            window.location.href = getUrl(`/userauth/ssoLogin/toLoginPage?clientType=${project}&backRoute=${encodeURIComponent(window.location.href)}`)
          } else {
            window.location.href = getUrl(`/supplier/#/member/login?url=${encodeURIComponent(window.location.href)}`)
            // vueInstantiation.$router.replace({
            //   path: '/member/login',
            //   query: { url: vueInstantiation.$route.fullPath, isHashJump: true }
            // })
          }
        } else if (authError && isJump) {
          // 如果不是登陆页面 并且是外部登录进来的
          if (data.loginSource === 'outer') {
            window.location.href = getUrl(`/userauth/ssoLogin/toLoginPage?clientType=${project}&backRoute=${encodeURIComponent(window.location.href)}${loginWay ? `&loginWay=${loginWay}` : ''}`)
          } else {
            vueInstantiation.$router.replace({
              path: '/member/login',
              query: {url: vueInstantiation.$route.fullPath, isHashJump: true}
            })
          }
        }
        handleAuthError = true
        showError = false
        vueInstantiation.$store.commit('setUserInfo', {loginStatus: false})
      } else if (data.code === 'NO_PERMISSION') {
        if (authError) {
          handleAuthError = true
          showError = false
          vueInstantiation.$router.replace({path: '/no-auth'})
        }
      } else if (data.code === 'NO_LEGAL') {
        if (authError) {
          handleAuthError = true
          showError = false
          vueInstantiation.$router.replace({path: '/no-auth'})
        }
      } else if (data.code === 'INVALID_TOKEN') {
        showError = false
        if (tokeInvalidError) {
          window.location.reload()
        }
      }

      if (showError && !handleAuthError) {
        if (code && code[data.code]) {
          Message({
            message: code[data.code].message,
            type: 'error'
          })
        } else {
          Message({
            message: data.errorMessage || pageText.networkAbnormalityTryAgain,
            type: 'error'
          })
        }
      }
    }
    // 请求状态 请求发送成功 后端返回异常
    data.requestState = true
    loading.hide && loading.hide()
    return data
  }).catch(function (err) {
    if (err && err.response) {
      const status = {
        400: {message: pageText.requestError},
        401: {message: pageText.unauthorizedPleaseLogIn},
        403: {message: pageText.accessDenied},
        404: {message: pageText.errorRequestAddress},
        408: {message: pageText.requestTimedOut},
        500: {message: pageText.serverInternalError},
        501: {message: pageText.serviceNotImplemented},
        502: {message: pageText.gatewayError},
        503: {message: pageText.serviceIsNotAvailable},
        504: {message: pageText.gatewayTimeout},
        505: {message: pageText.httpVersionNotSupported},
        default: {message: pageText.unknownMistake}
      }
      const statusCode = status[err.response.status] || status.default
      console.log(statusCode.message)
    }
    if (showError) {
      Message({
        message: (code && code['DEFAULT'] && code['DEFAULT'].message) || pageText.networkAbnormalityTryAgain,
        type: 'error'
      })
    }
    err.isOk = false
    // 请求状态 请求未发送成功
    err.requestFail = false
    // 隐藏loading
    loading.hide && loading.hide()
    return err
  })
}

// 获取响应状态
export function isResponseOk (res) {
  if (!res) {
    Message({
      message: pageText.networkAbnormalityTryAgain,
      type: 'error'
    })
    return
  }
  if (!res.success) {
    Message({
      message: res.errorMessage,
      type: 'error'
    })
    return
  }
  return true
}
